import styled from 'styled-components';

export interface PropsButton {
  margin?: string;
  padding?: string;
  noMin?: boolean;
}

export const MeButton = styled.button<PropsButton>`
  width: 100%;
  min-width: ${(props) => (props.noMin ? '0px' : '210px')};
  flex: 1;
  height: 48px;
  min-height: 48px;
  max-height: 48px;
  background-color: #3eab36;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  align-items: center;
  text-align: center;
  color: #ffffff;
  border-color: transparent;
  border-radius: 10px;
  @media only screen and (min-width: 1200px) {
    margin: ${(props) => (props.margin ? props.margin : 'none')};
  }
  padding: ${(props) => (props.padding ? props.padding : 'none')};

  :disabled {
    opacity: 1;
    cursor: not-allowed;
    background-color: #ccc;
    border-radius: 10px;
  }
  :focus {
    outline: none !important;
  }
  :hover {
    background: ${(props) => (props.disabled ? '#ccc' : '#3eab36')};
  }
`;
